module.exports = __webpack_public_path__ + "img/placeholder.8af4bb50.png";